<template>
    <div class="wallet-withdraw-warning">
        <section class="wallet-withdraw-warning__icon">
            <i class="icon icon-warning" />
        </section>
        <section class="wallet-withdraw-warning__content">
            <p class="wallet-withdraw-warning__content-title">
                {{ $t('withdrawWarningInfo.recipientsWarning.title') }}
            </p>
            <p class="wallet-withdraw-warning__content-text">
                <translation-string :translation="isChz ?
                    $t('withdrawWarningInfo.recipientsWarning.text') :
                    $t('withdrawWarningInfo.recipientsWarning.textFT')"
                />
            </p>
        </section>
    </div>
</template>

<script>
import translationString from '@webapp/components/translation-string.vue';

export default {
    name: 'wallet-withdraw-warning',
    components: {
        translationString,
    },
    props: {
        isChz: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss">
.wallet-withdraw-warning {
    display: flex;
    background: $orange-t-90;
    border-radius: 8px;
    margin-bottom: 20px;

    &__icon {
        width: 75px;
        background: $orange-t-30;
        border-radius: 8px 0 0 8px;
        padding-top: 15px;

        .icon {
            font-size: 28px;
            color: #fff;
        }
    }

    &__content {
        font-size: 14px;
        text-align: left;
        padding: 0 15px;

        &-title {
            font-weight: bold;
        }

        &-text {
            .translation-string > .translation-string__link {
                color: $blue-ribbon-color;
                cursor: pointer;
            }
        }
    }
}
</style>